// extracted by mini-css-extract-plugin
export default {"card":"markets__card__eh34q2","centered":"markets__centered__HGO5r2","content":"markets__content__yMGvod","fadeIn":"markets__fadeIn__mxtafk","header":"markets__header__TjtTTk"};